import React, { useEffect, useState } from "react";
import { FaQuoteLeft, FaRegSmile } from "react-icons/fa";

// Testimonial data (can loop through this)
const testimonials = [
  {
    id: 1,
    quote:
      "As I initiated the conversation with the enthusiastic Souvik, he begins by describing his wife Ranjana as a bubbly girl, who is the most understanding person he has ever met and who is his best friend. He attributes her characteristics and maturity to her being a teacher. He praises her for the way she deals with life situations. Meanwhile, Ranjana describes Souvik...",
    name: "Souvik & Ranjana",
    platform: "Matrimony",
    image: require("../../assets/souvik_ranjana.jpg"), 
  },
  {
    id: 2,
    quote:
      "Meeting through Matrimony was destiny for us. We were able to connect, understand each other, and start our beautiful journey together.",
    name: "Rahul & Priya",
    platform: "Matrimony",
    image: require("../../assets/rahul_priya.jpg"), // Replace with actual image path
  },
  // Add more items as needed
];

const TestimonialSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000); // 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="bg-[#fefefe] py-10">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-8">
        Millions have found their life partner at Matrimony!
      </h2>

      <div className="max-w-5xl mx-auto px-4">
        <div className="bg-white rounded-xl shadow p-6 md:flex md:items-center md:justify-between space-y-4 md:space-y-0 transition-all duration-500">
          {/* Left: Quote & details */}
          <div className="md:w-2/3 space-y-3">
            <FaQuoteLeft className="text-3xl text-orange-500 mb-2" />
            <p className="text-gray-700 text-lg leading-relaxed">
              {testimonials[currentIndex].quote}{" "}
              <span className="text-orange-600 font-medium cursor-pointer">
                Read more
              </span>
            </p>
            <div>
              <h3 className="font-bold text-xl">
                {testimonials[currentIndex].name}
              </h3>
              <p className="text-gray-600">
                {testimonials[currentIndex].platform}
              </p>
            </div>
          </div>

          {/* Right: Image */}
          <div className="md:w-1/3 flex justify-center">
            <img
              src={testimonials[currentIndex].image}
              alt={testimonials[currentIndex].name}
              className="rounded-lg shadow-md max-h-60 object-cover"
            />
          </div>
        </div>
      </div>

      {/* Bottom smile icon */}
      <div className="flex justify-center mt-4">
        <FaRegSmile className="text-2xl text-orange-400" />
      </div>
    </section>
  );
};

export default TestimonialSlider;
